//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObjectCollection.js";
import "../no/Session.js";
let d=[[],[[["id"],"RemoveWeldJointHandler",{},1,0],[["id"],"RemoveVariableBevelHandler",{},1,0],[["id"],"RemoveModifyFeatureHandler",{},1,0],[["id"],"RemovePointExitHandler",{},1,0],[["id"],"RemoveDatumIconHandler",{},1,0],[["id"],"RemovePipeJointSetType",{},1,0],[["id"],"RemoveJointPmiCreated",{},1,0],[["showSolids"],"ShowSolids",{},1,0],[["searchEntireAssembly","wantSolids","wantCurves","wantPoints","numFoundObjects","foundObjectsArray"],"LocateWelds",{},4,0],[["searchEntireAssembly","excludeInvisibleComponents","wantSolids","wantCurves","wantPoints","numFoundObjects","foundObjectsArray"],"LocateWeldsComponentOption",{},5,0],[["searchEntireAssembly","excludeInvisibleComponents","wantSolids","wantCurves","wantPoints","wantStructureWelds","numFoundObjects","foundObjectsArray"],"LocateWeldsIncludeStructure",{},6,0],[[],"ConvertLegacy",{},0,0],[["fsetFeatures"],"ConvertLegacySelected",{},1,0],[["fsetFeatures","createSingleFeatures"],"ConvertLegacyOptions",{},2,0],[["weldFeatures"],"CreateFeatureGroupsForCommonConnectedParts",{},1,0],[["weldTag"],"AskConnectedParts",{R_:{data:"Weld.ConnectedPart"}},1,0],[["selectedObjects"],"ImpactAnalysisCheck",{},1,0],[["selectedObjects"],"ImpactAnalysisConfirm",{},1,0],[["selectedObjects"],"ImpactAnalysisCheckConnectedParts",{},1,0],[["selectedObjects"],"ConvertTransformWeld",{},1,0],[["deleteOption","designObject"],"DeleteDesignFeatures",{},2,0],[["weldFeature","numFaceSets"],"HasSourceFacesInWeldPart",{R_:{areSourceFacesInWeldPart:""}},1,0],[["feature"],"GetMasterJointCollectorOfSplitFeature",{R_:{collector:"ScCollector"}},1,0],[["feature"],"ConvertLegacyJoint",{},1,0]],[]];
SPLM.Weld.CustomManager = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Weld.CustomManager";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Weld.CustomManager.DeleteOption = Object.freeze({
    "All" : "All", "InputOnly" : "InputOnly"});

SPLM.Weld.CustomManager.PmiSource = Object.freeze({
    "Preview" : "Preview", "FabricationPmi" : "FabricationPmi"});

export default SPLM;